import React from 'react'

const TabWidget = () => {
  return (
    <div>TabWidget</div>
  )
}

export default TabWidget